import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GeoFeaturesFragment = { __typename?: 'AuthenticatedUser', id: string, geoBasedFeatures?: { __typename?: 'GeoBasedFeatures', canToggleSpeakerDiarization?: boolean | null } | null };

export const GeoFeatures = /*#__PURE__*/ gql`
    fragment GeoFeatures on AuthenticatedUser {
  id
  geoBasedFeatures {
    canToggleSpeakerDiarization
  }
}
    ` as unknown as DocumentNode<GeoFeaturesFragment, unknown>;

        

        
export const useGeoFeaturesFragment = (
  input: string | Omit<UseFragmentOptions<GeoFeaturesFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'AuthenticatedUser' } };
    return input;
  })();

  return useFragment<GeoFeaturesFragment>({
    fragment: GeoFeatures,
    fragmentName: 'GeoFeatures',
    ...options,
  });
};
  
        